import React from 'react';
import { HiCheck, HiArrowRight, HiStar, HiBolt } from 'react-icons/hi2';
import { useScrollReveal } from '../utils/useScrollReveal';
import './Pricing.css';

// 👉 Replace these with your actual Stripe Payment Link URLs
// Create them at: https://dashboard.stripe.com/payment-links
const PLANS = [
  {
    name: 'Starter',
    price: 249,
    originalPrice: 349,
    period: 'one-time',
    description: 'Perfect for a single app launch',
    popular: false,
    features: [
      '1 platform (iOS, iPad, or Android)',
      '4 custom screenshots',
      '1 device frame style',
      '2 rounds of revisions',
      'Source files included',
      '72h delivery',
    ],
    cta: 'Get Started',
    paymentLink: 'https://buy.stripe.com/dRm8wH1Ml7jpergah60Ny0c',
  },
  {
    name: 'Pro',
    price: 449,
    originalPrice: 599,
    period: 'one-time',
    description: 'Best value for growing apps',
    popular: true,
    badge: 'Most Popular',
    features: [
      '2 platforms of your choice',
      '6 custom screenshots',
      'Multiple device frames',
      '3 rounds of revisions',
      'Source files + brand kit',
      '48h delivery',
      'App Store metadata text',
    ],
    cta: 'Get Pro',
    paymentLink: 'https://buy.stripe.com/28E3cn3Ut1Z5gzogFu0Ny0d',
  },
  {
    name: 'Enterprise',
    price: 749,
    originalPrice: 999,
    period: 'one-time',
    description: 'Full coverage for serious app businesses',
    popular: false,
    badge: 'Best Value',
    features: [
      'All platforms (iOS + iPad + Android)',
      '8 custom screenshots',
      'All device frames + custom',
      'Unlimited revisions',
      'Source files + full brand kit',
      '72h delivery',
      'App Store metadata + keywords',
      'A/B testing variants',
    ],
    cta: 'Go Enterprise',
    paymentLink: 'https://buy.stripe.com/dRmeV54YxcDJbf460Q0Ny0b',
  },
];

export default function Pricing() {
  const handleCheckout = (paymentLink) => {
    // If payment link is configured, open it. Otherwise scroll to contact.
    if (paymentLink && !paymentLink.includes('YOUR_')) {
      window.location.href = paymentLink;
    } else {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [headerRef, headerVisible] = useScrollReveal();
  const [gridRef, gridVisible] = useScrollReveal();

  return (
    <section className="pricing section" id="pricing">
      <div className="container">
        <div ref={headerRef} className={`pricing__header reveal ${headerVisible ? 'is-revealed' : ''}`}>
          <span className="section-label">Pricing</span>
          <h2 className="section-title">Pick a Plan. Get Screenshots.</h2>
          <p className="section-subtitle">
            One-time payment. Source files included. Delivered in 48h.
          </p>
        </div>

        <div className="pricing__guarantee">
          <HiStar />
          <span>100% Money-Back Guarantee — Not happy? Full refund within 7 days.</span>
        </div>

        <div ref={gridRef} className={`pricing__grid reveal-stagger ${gridVisible ? 'is-revealed' : ''}`}>
          {PLANS.map((plan, i) => (
            <div className={`pricing-card ${plan.popular ? 'pricing-card--popular' : ''}`} key={i}>
              {plan.badge && (
                <div className="pricing-card__badge">
                  {plan.popular && <HiBolt />}
                  {plan.badge}
                </div>
              )}
              <div className="pricing-card__header">
                <h3 className="pricing-card__name">{plan.name}</h3>
                <p className="pricing-card__description">{plan.description}</p>
              </div>

              <div className="pricing-card__price">
                <div className="pricing-card__price-row">
                  <span className="pricing-card__currency">$</span>
                  <span className="pricing-card__amount">{plan.price}</span>
                  <span className="pricing-card__original">${plan.originalPrice}</span>
                </div>
                <span className="pricing-card__period">{plan.period}</span>
                <span className="pricing-card__savings">
                  Save {Math.round((1 - plan.price / plan.originalPrice) * 100)}%
                </span>
              </div>

              <button
                className={`btn ${plan.popular ? 'btn-primary' : 'btn-secondary'} pricing-card__cta`}
                onClick={() => handleCheckout(plan.paymentLink)}
              >
                {plan.cta} <HiArrowRight />
              </button>

              <ul className="pricing-card__features">
                {plan.features.map((feature, j) => (
                  <li key={j}>
                    <HiCheck />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pricing__footer">
          <p>Need something custom? <button className="pricing__contact-link" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Contact us</button> for a tailored quote.</p>
        </div>
      </div>
    </section>
  );
}
